// extracted by mini-css-extract-plugin
export var centerText = "_7h-8";
export var container = "_7h-0";
export var doughnutContainer = "_7h-7";
export var legend = "_7h-a";
export var legendItemColorDisplay = "_7h-b";
export var legendItemLabel = "_7h-d";
export var legendItemValue = "_7h-c";
export var lg = "_7h-5";
export var maxWidth = "_7h-9";
export var md = "_7h-4";
export var responsive = "_7h-6";
export var sm = "_7h-3";
export var xs = "_7h-2";
export var xxs = "_7h-1";